import React from 'react'

import VocabularyWordPlaceholder from 'src/ui/VocabularyWord/VocabularyWordPlaceholder'

import VocabularyWordListSkeleton from './VocabularyWordListSkeleton'

const placeholderItems = Array.from({ length: 20 }).map((_, index) => ({
  id: index.toString(),
}))

const VocabularyWordListPlaceholder = () => (
  <VocabularyWordListSkeleton
    items={placeholderItems}
    ItemComponent={VocabularyWordPlaceholder}
  />
)

export default VocabularyWordListPlaceholder
